import { FC } from 'react';
import { Radio } from 'antd';
import classNames from 'classnames';

import { Option } from 'models/form';

type RadioGroupProps = {
	onChange?: ((e: any) => void) | undefined;
	options: Option[];
	id?: string;
	isQuiz?: boolean;
	defaultValue?: string;
	value?: string;
	isSettings?: boolean;
};

export const RadioGroup: FC<RadioGroupProps> = ({
	onChange,
	options,
	id,
	isQuiz,
	defaultValue,
	value,
	isSettings,
}) => {
	return (
		<div id={id}>
			<Radio.Group
				value={isSettings ? defaultValue : value}
				defaultValue={defaultValue}
				className={classNames({ checkbox: isQuiz })}
				options={options}
				onChange={(v) => {
					if (onChange) {
						onChange(v.target.value);
					}
				}}
			/>
		</div>
	);
};
